<!-- <div class="d-flex justify-content-between mb-4">
 
    <div *ngIf="gridData?.length && gridData.length > 0">

      <button class="btn btn-primary" (click)="exportToCSV()">
        Export to CSV
      </button>
    </div>
  </div> -->
  
  <div *ngIf="isJsonShow">

    {{gridPermissionByRole | json}}
  </div>
  
  <div class="form-group d-flex justify-content-end" *ngIf="gridData?.length && gridData.length > 0;">
    <span class="form-label mr-4" *ngIf="this.gridPermissionByRole.isApprovalPermission"><span class="">✅</span> Approve </span>
    <span class="form-label mr-4" *ngIf="this.gridPermissionByRole.isRejectPermission">  <span class="">❌</span> Reject </span>
    <span class="form-label mr-4" *ngIf="this.gridPermissionByRole.isSendToFirstAidPermission">  <span class="">🩺</span> Send To FirstAid </span>
    <span class="form-label mr-4" *ngIf="this.gridPermissionByRole.isFirstAidResolvePermission">  <span class="">🔄</span> Resolve By FirstAid </span>
    <span class="form-label mr-4" *ngIf="this.gridPermissionByRole.isAddNotesAddPermission">  <img src="assets/images/channel-add-icon.png" width="24" height="24" > Add Notes </span>
    <span class="form-label mr-4" *ngIf="this.gridPermissionByRole.isEditPermission"> <img src="assets/images/edit-icon.png" width="16" height="16" title="Edit App Coc Aoc Mapping"> Edit App Coc Aoc Mapping </span>
    <span class="form-label mr-4" *ngIf="this.gridPermissionByRole.isSendBackToApplicantPermission">  <span class="">↩️</span> Send Back To Applicant </span>
    <span class="form-label mr-4" *ngIf="this.gridPermissionByRole.isForwardToGAOPermission">  <span class="">➡️</span> Forward To GAO </span>
    
  </div>
  

  
  <ng-template #noData>
    <div class="d-flex flex-column justify-content-center align-items-center p-4 bg-light border rounded shadow-sm">
      <svg xmlns="http://www.w3.org/2000/svg" 
           width="120" height="120" 
           viewBox="0 0 24 24" 
           fill="none" stroke="#2563eb" 
           stroke-width="2" stroke-linecap="round" stroke-linejoin="round" 
           style="opacity: 0.9;" class="mb-3">
        <rect x="3" y="4" width="18" height="16" rx="2" ry="2"></rect>
        <line x1="8" y1="10" x2="16" y2="10"></line>
        <line x1="8" y1="14" x2="14" y2="14"></line>
      </svg>
  
      <h5 class="text-primary">No Applications Found</h5>
      <p class="text-secondary small">Try adjusting filters or check back later.</p>
    </div>
  </ng-template>











  
  
  <div class="table-container scrollbar" *ngIf="gridData?.length && gridData.length > 0; else noData">
    <ag-grid-angular class="ag-theme-quartz auto-height commontable"
      [rowData]="gridData"
      [columnDefs]="displayedColumnDefs"
      [defaultColDef]="defaultColDef"
      [suppressRowClickSelection]="false"
      [pagination]="false"
      [paginationPageSize]="paginationPageSize"
      [class]="themeClass"
      (gridReady)="onGridReady($event)"
      [gridOptions]="gridOptions">
    </ag-grid-angular>
  
    <div class="d-flex justify-content-end align-items-center">
      <!-- Pagination Controls -->
      <ul class="pagination mb-0">
        <!-- First Page -->
        <li class="page-item" [class.disabled]="currentPage === 1">
          <button class="page-link" (click)="goToFirstPage()" [disabled]="currentPage === 1">First</button>
        </li>
    
        <!-- Previous Page -->
        <li class="page-item" [class.disabled]="currentPage === 1">
          <button class="page-link" (click)="goToPreviousPage()" [disabled]="currentPage === 1">Previous</button>
        </li>
    
        <!-- Current Page -->
        <li class="page-item disabled">
          <span class="page-link">Page {{ currentPage }} of {{ totalPages }}</span>
        </li>
    
        <!-- Page Size Dropdown -->
        <!-- <li class="ms-2">
          <select id="pageSizeSelector" class="form-select form-select-sm" [(ngModel)]="paginationPageSize" (change)="onPageSizeChange()" >
            <option *ngFor="let size of paginationPageSizeSelector" [value]="size">{{ size }}</option>
          </select>
        </li> -->
  
  
        <li class="ms-2">
          <select
            id="pageSizeSelector"
            class="form-select form-select-sm page-link"
            [(ngModel)]="paginationPageSize"
            (change)="onPageSizeChange()"
            style="width: auto;"
          >
            <option *ngFor="let size of paginationPageSizeSelector" [value]="size">{{ size }}</option>
          </select>
        </li>
    
        <!-- Next Page -->
        <li class="page-item" [class.disabled]="currentPage === totalPages">
          <button class="page-link" (click)="goToNextPage()" [disabled]="currentPage === totalPages">Next</button>
        </li>
    
        <!-- Last Page -->
        <li class="page-item" [class.disabled]="currentPage === totalPages">
          <button class="page-link" (click)="goToLastPage()" [disabled]="currentPage === totalPages">Last</button>
        </li>
      </ul>
    </div>
  </div>
  
  <!-- Image Preview Container -->
  <div class="preview-container" *ngIf="showPreview">
    <div class="image-preview-popup" 
         [style.left.px]="previewPosition.x" 
         [style.top.px]="previewPosition.y"
         (mouseenter)="onPreviewMouseEnter()"
         (mouseleave)="onPreviewMouseLeave()">
      <div class="preview-content">
        <img [src]="previewImageUrl" alt="Image Preview" class="preview-image">
        <div class="preview-close" (click)="hideImagePreview()">×</div>
      </div>
    </div>
  </div>
  
  
  
  
  